import { QUERY_STRING_ACQUIRED } from './mle-actions';

export const initialState = {
  girlId: ''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case QUERY_STRING_ACQUIRED: {
      return action.payload;
    }

    default:
      return state;
  }
};
